import {
  ONBOARDING_BILLING_PLAN,
  ONBOARDING_EMAIL_SETUP,
  ONBOARDING_PROFILE_SETUP,
} from "../navigation/CONSTANTS";

/*
 * Wizard onboarding statuses from GET /api/user/onboarding/steps.
 *
 * Do not confuse these with jobstatus.isOnboardingCompleted — that flag is
 * the 7-day/60-day forecast sync, not this profile/billing/email wizard.
 *
 * Incomplete: JustInstalled, UserProfileProvided, BillingSuccessful,
 * HistoricalOrderAuthorised, HistoricalOrderDenied.
 * Complete: OnboardingCompleted.
 */
export const ONBOARDING_COMPLETED = "OnboardingCompleted";

const WIZARD_INCOMPLETE_STATUSES = [
  "JustInstalled",
  "UserProfileProvided",
  "BillingSuccessful",
  "HistoricalOrderAuthorised",
  "HistoricalOrderDenied",
];

export function isWizardOnboardingIncomplete(status) {
  return WIZARD_INCOMPLETE_STATUSES.includes(status);
}

/*
 * Where to send a merchant who has not finished the wizard.
 * Same mapping as embedded boot in authenticateEmbeddedSessionAction.
 *
 * Example: "UserProfileProvided" → "/ui/onboarding/billingplan"
 */
export function getWizardOnboardingRedirect(status) {
  switch (status) {
    case "JustInstalled":
      return ONBOARDING_PROFILE_SETUP;
    case "UserProfileProvided":
      return ONBOARDING_BILLING_PLAN;
    case "BillingSuccessful":
      return `${ONBOARDING_EMAIL_SETUP}?action=billing_success`;
    case "HistoricalOrderAuthorised":
    case "HistoricalOrderDenied":
      return ONBOARDING_EMAIL_SETUP;
    default:
      return null;
  }
}
